import type { CommentThreadScrollRequest } from "features/script-editor/components/script-comments-panel/ScriptCommentsPanel";
import type { ScheduleCommentAnchorTarget } from "components/dashboard/body/projects/panels/schedule/comments/scheduleCommentAnchors";

export type OpenProjectCommentsOptions = {
  scrollToThreadId?: string;
  anchorTarget?: ScheduleCommentAnchorTarget;
};

export type ProjectCommentsShellState = {
  isOpen: boolean;
  scrollToThreadRequest: CommentThreadScrollRequest | null;
  pendingScheduleRootAnchor: ScheduleCommentAnchorTarget | null;
};

export const DEFAULT_PROJECT_COMMENTS_SHELL_STATE: ProjectCommentsShellState = {
  isOpen: false,
  scrollToThreadRequest: null,
  pendingScheduleRootAnchor: null,
};

export type ScreenplayCommentGoToRequest = {
  paragraphId: number;
  sceneId?: number | null;
};

export type ScreenplayCommentGoToHandler = (paragraphId: number, sceneId?: number | null) => void;

export type ScheduleCommentScrollHandler = (targetId: string) => void;
